<template>

    <BModal v-model="checked" :title="'Room ' + (props.data.item?.code ?? props.data.item?.reservation?.room?.code ?? '-')" no-close-on-backdrop >
        
        <BRow class="form-group">
            <BCol>
                <!-- <BFormInput v-model="postData.maintenance_type" placeholder="Maintenance Type"></BFormInput> -->
                <BFormSelect v-model="postData.name" :options="optionMaintenanceType"></BFormSelect>
            </BCol>
        </BRow>
        <BRow class="form-group">
            <BCol>
                <!-- <BFormInput v-model="postData.name" placeholder="Technician Name"></BFormInput> -->
                <BFormSelect v-model="postData.employee_uuid" :options="optionTechnician"></BFormSelect>
            </BCol>
        </BRow>
        <BRow>
            <BCol>
                <div class="form-group">
                <label for="">Start Date</label>
                <BFormInput type="date" v-model="postData.start">
                    
                </BFormInput>
                </div>
            </BCol>
            <BCol>
                <div class="form-group">
                <label for="">End Date</label>
                <BFormInput type="date" v-model="postData.end">
            
                </BFormInput>
                </div>
            </BCol>
        </BRow>
        <template v-if="hasReservationRoom">
            <BRow class="form-group">
                <BCol>
                    <BFormSelect
                    v-model="postData.room_category"
                    :options="optionRoomCategory"
                    >
                    </BFormSelect>
                </BCol>
            </BRow>

            <BRow class="form-group" v-if="postData.room_category">
                <BCol>
                    <BFormSelect
                    v-model="postData.room_uuid_change"
                    :options="optionRoomItems"
                    text-field="code"
                    value-field="uuid"
                    
                    >
                    <template #first>
                        <BFormSelectOption :value="null" disabled>
                        Select Room Number
                        </BFormSelectOption>
                    </template>

                    </BFormSelect>
                </BCol>
            </BRow>
        </template>

        <BRow class="form-group">
            <BCol>
                <BFormTextarea 
                type="text"
                v-model="postData.description" 
                placeholder="Remark(*optional)">
            </BFormTextarea>
            </BCol>
        </BRow>
        <template #footer>
          <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="setMaintenance()" class="mr-2">Save</BButton>
            <BButton variant="danger" @click="checked = false">Cancel</BButton>
          </div>
        </template>
    </BModal>
    
    <ToastResponse
        v-model="modalResponse.toast"
        :text="modalResponse.text"
        :success="modalResponse.success"
    ></ToastResponse>
    
</template>

<script setup>
import { BModal,BFormInput,BRow,BCol, BFormTextarea,BButton, BFormSelect } from 'bootstrap-vue-next'
import { defineModel, defineProps, ref, reactive, inject, computed, onMounted, watch } from 'vue'
import router from '@/router';
import ToastResponse from "@/components/ToastResponse.vue";
import { getAll } from '@/services/guestService';

const checked=defineModel()

const props = defineProps({
    data: Object
})

//const emit = defineEmits(["success", "close"])

const postData = reactive({
    //room_uuid : props.data.item.uuid || props.data.item.number,
    reservation_uuid : props.data.item?.reservation_uuid,
    room_uuid : props.data.item?.uuid || props.data.item?.reservation?.room?.uuid,
    name : null,
    employee_uuid : null,
    room_category : null,
    room_uuid_change: null,
    start : '',
    end : '',
    days : '',
    description : '',
})

const repositories = inject('repositories');
const setMaintenanceRepository = repositories ? repositories.maintenance : null;
const maintenanceIssueRepository = repositories ? repositories.maintenanceIssue : null;
const technicianRepository = repositories ? repositories.employee : null; 
const roomCategoryRepository = repositories ? repositories.roomCategory: null;
const roomRepository = repositories ? repositories.rooms : null;

const rooms = ref([]);

const calculateDays = computed(() => {

    if (postData.start && postData.end) {
    const startDate = new Date(postData.start);
    const endDate = new Date(postData.end);

    const timeDifference = endDate - startDate;

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference > 0 ? daysDifference : 0;
    }
    return 0;
});

const hasReservationRoom = computed(
  () => !!props.data.item?.reservation?.room?.code
);

const modalResponse = ref({
    toast: false,
    text: "",
    success: false,
});

const optionMaintenanceType = ref([
{value: null, text: 'No maintenance options'},
])

const optionTechnician = ref([
{value: null, text: 'No technician options'},
])

const optionRoomCategory = ref([
{value: null, text: 'No room category options'},
])

// const optionRoomItems = ref([
// {value: null, text: 'No room number options'},
// ])


// Ambil data maintenance issue untuk field dropdown maintenance type
const getMaintenanceIssue = async () => {
    try{
        const response = await maintenanceIssueRepository.getAll()
        optionMaintenanceType.value = response.data.data.map(item => ({
            value: item.name,
            text: item.name,
        }))
        optionMaintenanceType.value.unshift({ value: null, text: 'Select maintenance issue' })
    }catch(e){
        console.log(e)
    }
}

const getTechnicianList = async () => {
    try{
        const response = await technicianRepository.getAll()

        // Filter hanya yang posisi Technician
        const technicianOnly = response.data.data.filter(item => item.position_name === 'Technician')

        optionTechnician.value = technicianOnly.map(item => ({
            value: item.uuid,
            text: item.fullname,
        }))
        optionTechnician.value.unshift({ value: null, text: 'Select technician' })
    }catch(e){
        console.log(e)
    }
}

const getRoomCategoryList = async () => {
    try{
        const response = await roomCategoryRepository.getAll()

        optionRoomCategory.value = response.data.data.map(item => ({
            value: item.name,
            text: item.name,
        }))
        optionRoomCategory.value.unshift({ value: null, text: 'Move guest to other room:' })
    }catch(e){
        console.log(e)
    }
}

const getRoomList = (category) => {
    roomRepository
    .getAll({
        category: category,
        room_uuid : props.data.item?.reservation?.room?.uuid
    })
    .then((res) => {
        rooms.value = res.data.data;
    })
    .catch((err) => {
        console.error(err);
    });
};

const optionRoomItems = computed(() => {
    return rooms.value.filter((room) => 
    room.room_category.name === postData.room_category &&
    room.status === 'available' 
    );
    
});
optionRoomItems.value.unshift({ value: null, text: 'No room available' })

// const handleSelectedRoom = (event) => {
//       const selectedRoom = rooms.value.find((room) => room.uuid === event);
//       console.log(selectedRoom);
//     };

const setMaintenance = async ()=>{
    postData.days = calculateDays
    postData.description = postData.description === null ? '-' : postData.description
    try{
        console.log("data yang diupdate", postData);
        const updateData =  await setMaintenanceRepository.create(postData)

        // Kalau sukses, tutup modal
        //this.checked = false;

        modalResponse.value = {
            toast: true,
            text: updateData.data.message || 'Update Successfully',
            success: true,
        };

        // emit("success");   // untuk refresh data di DataTable
        // emit("close");     // untuk menutup modal
        router.go(0) // Refresh halaman
    }catch(e){
        modalResponse.value = {
            toast: true,
            text: e.response?.data?.message || 'Update failed!',
            success: false,
          }
        console.log(e)
    }
}

watch(
  () => postData.room_category,
  (val) => {
    if (val) getRoomList(val)
    postData.room_uuid_change = null          // reset pilihan kamar
    rooms.value = []                   // bersihkan dulu => spinner/empty state
  }
)

onMounted(()=>{
    getMaintenanceIssue()
    getTechnicianList()
    getAll()
    getRoomCategoryList()
    getRoomList()
})


</script>